var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00036 0C3.13379 0 3.79829e-08 3.1338 3.79829e-08 6.99964C-9.57303e-05 7.91896 0.180909 8.82931 0.532676 9.67867C0.884443 10.528 1.40008 11.2998 2.05015 11.9499C2.70021 12.5999 3.47196 13.1156 4.32133 13.4673C5.17069 13.8191 6.08104 14.0001 7.00036 14C10.8655 14 14 10.8662 14 6.99964C14 3.1338 10.8655 0 7.00036 0ZM7.65366 2.52716C8.33613 2.52716 8.53664 2.92308 8.53664 3.37587C8.53664 3.94094 8.08458 4.46373 7.31243 4.46373C6.66642 4.46373 6.35873 4.13926 6.37769 3.6019C6.37769 3.14911 6.75611 2.52716 7.65366 2.52716ZM5.90521 11.1921C5.43857 11.1921 5.09807 10.9085 5.42399 9.66533L5.95844 7.45972C6.05104 7.10682 6.06635 6.96537 5.95844 6.96537C5.81918 6.96537 5.21327 7.2089 4.856 7.44951L4.6234 7.06817C5.7572 6.12104 7.06088 5.56544 7.61866 5.56544C8.08531 5.56544 8.16259 6.11666 7.93 6.96537L7.31754 9.284C7.2089 9.69377 7.25556 9.83522 7.3642 9.83522C7.50419 9.83522 7.96209 9.66606 8.41269 9.31097L8.67663 9.66533C7.57346 10.7678 6.37113 11.1921 5.90521 11.1921Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfo);
export default __webpack_public_path__ + "static/media/tooltip-info.35bd7f79391f2984c83ba2f20d8de1d4.svg";
export { ForwardRef as ReactComponent };